import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import {
  TdDataTableService,
  TdDataTableSortingOrder,
  ITdDataTableSortChangeEvent,
  ITdDataTableColumn,
  TdDataTableComponent,
  TdDialogService,
  IPageChangeEvent,
  TdLoadingService
} from '@covalent/core';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { InventoryService } from '../../../inventory/inventory.service';
import { SettingsService } from '../../../../shared/services/settings.service';
import { Branch } from '../../../accounting/branch';
import { Observable } from 'rxjs/Observable';
import { Utils } from '../../../../shared/utils';
import { Subscription } from 'rxjs/Subscription';
import { LocationService } from 'services/location.service';
import { ReceivingItem } from '../../../receiving/receiving-item';
import { ReceivingService } from '../../../receiving/receiving.service';
import { Receiving } from '../../../receiving/receiving';

@Component({
  selector: 'app-multi-scan',
  templateUrl: './multi-scan.component.html',
  styleUrls: ['./multi-scan.component.scss']
})

export class MultiScanComponent implements OnInit {
  dataTable: TdDataTableComponent;
  _subscription: Subscription = new Subscription();
  title: string;
  itemLocation: any;

  id: string;
  
  items: any[] = [];

  locations: any[] = [];
  addPiece: any;

  //For the movement
  pieceNumber: any;
  inputNumber: any;
  flag: boolean ;
  piece_location: string;
  newLocation: string;

  allBranches$: Observable<Branch[]>;

  branchFilter: number;

  multiMode: boolean = false;

  columns: ITdDataTableColumn[] = [
    { name: 'collection_name', label: 'Collection', tooltip: '' },
    { name: 'design_name', label: 'Design', tooltip: '' },
    { name: 'color_name', label: 'Color', tooltip: '' },
    { name: 'length', label: 'Meters' },
    { name: 'piece_number', label: 'Piece Number', tooltip: '' },
    { name: 'lot_number', label: 'Lot Number' }
  ];


  filteredData: any[] = [];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[] = [];
  unselectedRows: any[] = [];
  tempRows: any[] = [];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;
  selectable: boolean = true;
  multipleSelect: boolean = true;
  piece_no: any;
  piece_numbers: any;
  order_items: ReceivingItem[] = [];
  order: Receiving = new Receiving();
  order_number: string = '';
  _branch_id: number;
  
  external_order: boolean = true;

  constructor(
    private _dialogService: TdDialogService,
    private router: Router,
    public _settingsService: SettingsService,
    private _dataTableService: TdDataTableService,
    private location: Location,
    private _loadingService: TdLoadingService,
    public _authService: AuthenticationService,
    private _inventoryService: InventoryService,
    private _receivingService: ReceivingService,
    private _locationService: LocationService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this._subscription.add(
      this.route.params.subscribe(
        params => {
          this.id = params['recv_id'];
          this._subscription.add(
            this._receivingService.getReceivingItems(this.id + '').subscribe(
              response => {
                console.log("aici avem items order");
                this.order_items = response;
                console.log(this.order_items);
              }
            )
          )

          this._subscription.add(
            this._receivingService.getReceiving(this.id).subscribe(
              response => {
                this.order = response;
              }
            )
          );
        }
      )
    )

    this.route.queryParams.subscribe(
      params => {
        this.order_number = params['order_number'];
        this._branch_id = params['branch_id'];
        this.external_order = (params['supplier_id'] != null && params['supplier_id'] != 'null');

        // Get locations for the specific branch
        this.getLocations();
      }
    );
    this.branchFilter = this._authService.getUserBranches().find(b => { return b.id == this._authService.getHomeBranch() }).id;
    this.allBranches$ = Observable.of(this._authService.getUserBranches());
    this.getLocations();
  }

  goBack(): void {
    this.location.back();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter([]);
  }

  findItems(location: string, selitem: any[]): void {
    if(this.selectedRows.length == 0)
      this.selectedRows = [];
    this._loadingService.register('loading');
    this._inventoryService.findByLocation(location, this.branchFilter).subscribe(
      response => {
        this.items = response;
        
        this.filter(selitem);

        this._loadingService.resolve('loading');
      }
    );
  }

  totalPieces() {
    return this.items.length;
  }

  totalMeters() {
    return this.filteredData.reduce((a, b) => { return a * 1 + b['length'] * 1 }, 0).toFixed(3);
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter([]);
  }

  filter(piece_no: any[]): void {
    let newData: any[] = this.items;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this.searchTerm, true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;

    if (this.filteredTotal < 1) {
      this._dialogService.openAlert({
        message: 'No matching location found or location is empty!',
        title: 'Error'
      });

    }
    if(piece_no.length>0){

      for(let i =0; i<piece_no.length; i++){
        let this_item = this.filteredData.find((item) => { 
          return item['piece_number'] == piece_no[i] });
        
        if(this_item!=undefined){
          this.select(true, this_item);
        }
      }

      
    }
  }


  //CHECKBOX----
  select(selected: boolean, row) {
    
    if (selected) {
      if (!this.selectedRows.some(item => { return item["piece_number"] == row["piece_number"] })) 
        this.selectedRows.push(row);
    } else 
      this.selectedRows = this.selectedRows.filter(item => { return item["piece_number"] != row["piece_number"] })
  }

  rowSelected(row) {
    return this.selectedRows.some((selected) => { return selected["piece_number"] == row["piece_number"] });
  }

  allSelected() {
    // Are there as many selected as there are in the list?
    return this.filteredData.length == this.selectedRows.length;
  }

  selectAll() {
    let selected = !this.allSelected();
    //let selected= !(this.filteredData.length == this.selectedRows.length);

    if (selected) {
      this.filteredData.forEach(
        item => {
          this.select(true, item);
        }
      );
    } 
  }

  //END CHECKBOX---------

  //CHANGE LOCATION--------
  
  getLocations() {
    this._locationService.getLocations(this._authService.getHomeBranch() + '').subscribe(
      response => {
        this.locations = response;
      }
    );
  }

  scanNumber(inputNumber) {
    this.flag = false;
    let dummy_text : string[] = [];

    if( inputNumber.indexOf(',') >= 0){
      dummy_text = inputNumber.split(",");
      
    for(let j=0; j<dummy_text.length; j++){
      dummy_text[j]= dummy_text[j].trim();
      console.log(dummy_text[j].trim());
    }

    for(let l=0; l<dummy_text.length; l++){
      this.items.every(
        item => {
          if(item["piece_number"]==dummy_text[l])
            {
            console.log("verifica" + dummy_text[l]);
            this.select(true, item);
            this.flag = true;
            return false;
            } 
            return true;
          }
          
      );
  }}      
    else {
      this.items.every(
        item => {
          if(item["piece_number"]==inputNumber)
            {
            console.log("verifica" + inputNumber);
            this.select(true, item);
            this.flag = true;
            return false;
            } 
            return true;
          }
          
      );
    }

    if(this.selectedRows.length < 1)
      this.alertSuccess();
    
      if(this.flag==false)
    {
      this._dialogService.openConfirm({
        title: 'Piece not found',
        message: 'Do you want to add it?',
        cancelButton: 'Disagree', //OPTIONAL, defaults to 'CANCEL'
        acceptButton: 'Agree', //OPTIONAL, defaults to 'ACCEPT'
        
      }).afterClosed().subscribe((accept:boolean)=>{
        if(accept) 
          this.router.navigate(['/inventory', 'list', 'piece']);
      });
    }
    console.log(this.inputNumber);
    this.inputNumber='';
  }

  // ----------------------- de aici

  scanned() {
    if (this.multiMode) {
      this.scanMulti();
    } else {
      this.scanOne();
    }
  }

  scanOne() {    

    let this_item: ReceivingItem = this.items.find((item) => { 
      return item['piece_number'] == this.piece_no });

    if (this_item == null) {
      
      this._dialogService.openConfirm({
        title: 'Piece not found',
        message: 'Do you want to add it?',
        cancelButton: 'Disagree', //OPTIONAL, defaults to 'CANCEL'
        acceptButton: 'Agree', //OPTIONAL, defaults to 'ACCEPT'
        
      }).afterClosed().subscribe((accept:boolean)=>{
        if(accept) 
          // this.router.navigate(['/inventory', 'list', 'piece']);

          if(this.piece_no != null){
            this._inventoryService.changeLocation(this.piece_no, this.itemLocation, this.branchFilter).subscribe(
              response => {
                if (response['status'] == 'SUCCESS') {
                  this.sentMessage += this.piece_no + '|';
                } else {
                  this.errorMessage += this.piece_no + '|';
                }
              }
            );
            let dummy : any[] =[];
            dummy.push(this.piece_no);

            this.findItems(this.itemLocation, dummy);
            
          }
      });
      return;
    } 
    else {
      this.select(true, this_item);
    }
    this.piece_no = undefined;
  }


  scanMulti() {

    let sellist = this.piece_numbers.split(/\s+/);

    sellist.forEach(
      p => {
        let this_item: ReceivingItem = this.items.find((item) => { 
          return item['piece_number'] == p });

        if (this_item == null) {
          this._dialogService.openConfirm({
            title: 'Piece not found',
            message: 'Do you want to add it?',
            cancelButton: 'Disagree', //OPTIONAL, defaults to 'CANCEL'
            acceptButton: 'Agree', //OPTIONAL, defaults to 'ACCEPT'
            
          }).afterClosed().subscribe((accept:boolean)=>{
            if(accept) 
            {
              if(p != null){
                this._inventoryService.changeLocation(p, this.itemLocation, this.branchFilter).subscribe(
                  response => {
                    if (response['status'] == 'SUCCESS') {
                      this.sentMessage += p + '|';
                    } else {
                      this.errorMessage += p + '|';
                    }
                  }
                );
                
              }
              this.findItems(this.itemLocation, sellist);

            }
          });
          return;
        } 
      }
    );

    this.findItems(this.itemLocation, sellist);

    this.piece_numbers = '';
  }

  moveSelectedToTemp() {

    if(this.selectedRows.length==0){
      this._dialogService.openAlert({
        title: 'Invalid Location',
        message: 'There is nothing selected!'
      });
      return;
    } else if (this.selectedRows.length > 0) {
      this._loadingService.register('loading');
    }

    this.items.forEach(
      item => {
        let jdex=0;
        if(item["piece_number"]!=this.selectedRows[jdex]["piece_number"])
        this.unselectedRows[jdex] = item["piece_number"];
        console.log("so on" + this.unselectedRows[jdex]);
        jdex++;
        }
        
    );

    for (let i = 0; i < this.unselectedRows.length; i++) {
      let pieceNumber = this.unselectedRows[i];
      if (pieceNumber == "undefined") {
        this.hasNoPieceNumber = true;
        continue;
      }

      if (pieceNumber) {
        this._inventoryService.changeLocation(pieceNumber, "TEMP", this.branchFilter).subscribe(
          response => {
            if (response['status'] == 'SUCCESS') {
              this.sentMessage += pieceNumber + '|';

            } else {
              this.errorMessage += pieceNumber + '|';
            }

            if (i == this.unselectedRows.length - 1) {
              this._loadingService.resolve('loading');
              this.alertSuccess();
            }
          }
        );
      } else {
        this.hasNoPieceNumber = true;
      }
    }
  }

  sentMessage: string = '';
  errorMessage: string = '';
  toadderrorMessage: string = '';
  hasNoPieceNumber: boolean = false;

  alertSuccess(): void { // TO DO CHANGE THE MESSAGES

    this.errorMessage = this.errorMessage.slice(0, -1);
    this.sentMessage = this.sentMessage.slice(0, -1);

    if (this.errorMessage) {
      if (this.sentMessage) { //Case error +success 
        this._dialogService.openAlert({
          message: 'Pieces numbers:' + this.sentMessage + ' found!',
          title: 'Success'
        }).afterClosed().subscribe(r => this.goBack());

        this._dialogService.openAlert({
          message: 'Input number not found:' + this.errorMessage,
          title: 'Error'
        });
      } else { //Case only error
        this._dialogService.openAlert({
          message: 'No matching location found:' + this.errorMessage,
          title: 'Error'
        }).afterClosed().subscribe(r => this.goBack());
      }

    } else if (this.sentMessage) { //Case only success
      this._dialogService.openAlert({
        message: 'Piece no: ' + this.sentMessage,
        title: 'Success'
      }).afterClosed().subscribe(r => this.goBack());
    }

    this.sentMessage = '';
    this.errorMessage = '';
    this.hasNoPieceNumber = false;

  }

  //END CHANGE LOCATION--------
}
function ViewChild(arg0: string) {
  throw new Error('Function not implemented.');
}


// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/pda/inventory/multi-scan/multi-scan.component.ts